var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-generator',{attrs:{"schema":_vm.formSchema,"value-class":""},model:{value:(_vm.reactiveValue),callback:function ($$v) {_vm.reactiveValue=$$v},expression:"reactiveValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }